// extracted by mini-css-extract-plugin
module.exports = {"header":"ViewCart_header__3tO4R","title":"ViewCart_title__3NyTb"};